import { useEffect, useState, useRef } from 'react'
import './call-resume-pdf.scss'
import ComplianceHits from './ComplianceHits'
import ComplianceImprovents from './ComplianceImprovents'
import LoadingReport from './LoadingReport';
 
export default function CallReportResumePDF({ data, onLoadComplete  }) {
  const [call, setCall] = useState(data);
  const [positive, setPositive] = useState(0)
  const [neutro, setNeutro] = useState(0)
  const [negative, setNegative] = useState(0)
  const [total, setTotal] = useState(0)
  const targetRef = useRef();
 
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    if (data) {
      setCall(data);
      let positive_count = 0;
      let negative_count = 0;
      let neutro_count = 0;
      let total_sum = 0;

      data.sentiment?.forEach(item => {
        if (item.polarity === 'POS') {
          positive_count += 1;
          total_sum += 1;
        } else if (item.polarity === 'NEU') {
          neutro_count += 1;
          total_sum += 0;
        } else if (item.polarity === 'NEG') {
          negative_count += 1;
          total_sum -= 1;
        }
      });

      setNegative(negative_count);
      setPositive(positive_count);
      setNeutro(neutro_count);

      const score = (total_sum / (data.sentiment?.length || 1));
      setTotal(((score + 1) / 2).toFixed(2));

      setLoading(false);
      if (onLoadComplete) {
        onLoadComplete();
      }
    }
  }, [data, onLoadComplete]);

  if (loading) {
    return <LoadingReport />;
  }
 
  return (
    <div ref={targetRef}>
      <div className="info-call-pdf w-full" style={{ backgroundColor: 'white', paddingTop: 10 }}>
        <div className="info-call-item-pdf header-pdf">
          <div className="item-pdf">
            <h4 className="font-bold text-[#0B5FA3] text-[18px]">Call Time</h4>
            <span className="duration-call-pdf text-[#575756] text-[29px]">{call?.time_call}</span>
            <div className="subitems-pdf">
              <div>
                <h4 className='font-bold text-[#0B5FA3]'>N° Times in Hold</h4>
                <span className='text-[#575756]'>{call.time_hold}</span>
              </div>
              <div>
                <h4 className='font-bold text-[#0B5FA3]'>Total Hold Time (sec)</h4>
                <span className='text-[#575756]'>{call.second_hold}</span>
              </div>
            </div>
          </div>
          
          <div className="item-pdf">
            <h4 style={{fontWeight: "bold",color: "#0B5FA3", fontSize: 18}}>Score</h4>
            <span className="porcentaje-pdf" style={{color: '#0B5FA3', fontSize: 39}}>{Number((call.qualification * 100).toFixed(1))}%</span>
          </div>

          <div style={{ marginTop: 20, padding: 10, fontSize: 16 }}>
            <h4 style={{ fontSize: 18, fontWeight: "bold",color: "#0B5FA3" }}>Bot sentiment result:</h4>
            <div className="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', color: "#575756" }} >
              <div className="m-1" style={{ fontWeight: "bold",color: '#575756' }}>Positive:</div>
              <div style={{ marginLeft: 3 }}>{positive}</div>
            </div>
            <div className="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', color: '#575756' }}>
              <div style={{ fontWeight: "bold",color: '#575756' }}>Neutral:</div>
              <div style={{ marginLeft: 3 }}>{neutro}</div>
            </div>
            <div className="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', color: '#575756' }}>
              <div style={{ fontWeight: "bold",color: '#575756' }}>Negative:</div>
              <div style={{ marginLeft: 3 }}>{negative}</div>
            </div>
            <div className="d-flex flex-row align-items-center" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', color: "#575756" }}>
              <div className="m-1" style={{ fontWeight: "bold",color: '#575756' }}>Polarity score:</div>
              <div style={{ marginLeft: 3, letterSpacing: 1 }}>{total}</div>
            </div>
          </div>

          <div className="highlights-pdf">
            <h4 style={{ padding: 0, margin: 0 ,fontWeight: "bold", color: "#0B5FA3"}}>Highlights</h4>
            <div>
              <img src="/icons/sentiment2.png" alt="" style={{ width: 142, height: 143, objectFit: 'contain' }} />
            </div>
          </div>
        </div>

        <div className="info-call-item-pdf body-pdf">
          <div>
            <h2 className="font-bold text-[#0B5FA3] text-[18px]" >Hits</h2>
            <div className="container-call-info-no-scroll">
              <ComplianceHits data={call} />
            </div>
          </div>
          <div style={{ paddingRight: 15 }}>
            <h2 className="font-bold text-[#0B5FA3] text-[18px]" >Improvements</h2>
            <div className="container-call-info-no-scroll">
              <ComplianceImprovents data={call} />
            </div>
          </div>
        </div>
      </div>

      <div className="info-call-pdf w-full" style={{ backgroundColor: 'white', paddingTop: 10 }}>
          <div class="info-call-item-pdf header-pdf flex items-center w-full justify-center" style={{ padding: 15, backgroundColor: "white" }} >
              <div class="agents-pdf flex items-center ">
                  <div class="img">

                      <img alt='' src="/icons/tpAgent.png" style={{ width: 150, objectFit: 'contain', marginRight: 30 }} />

                  </div>
                  <div class="img">
                      <img src="/icons/tpClient.png" alt="" style={{ width: 180, objectFit: 'contain' }} />
                      {/* <!--<span>TP Client</span>--> */}
                  </div>
              </div>
              <div class="higilights-pdf">
                  <img alt="" src="/icons/sentiment2.png" style={{ width: 142, height: 143, objectFit: 'contain' }} />
              </div>
          </div>
          <div class="call-resume-container-pdf" >
              <div class="call-resume-loading-pdf">
                  <h2>Conversation</h2>
              </div>
              <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                  <div id="sidebar-chat" class="call-resume-indicators-pdf" >
                      {call?.sentiment.map((item, idex) => (
                          <div class="call-resume-text-container-pdf"  >
                              {item.user !== '' &&
                                  <div class="call-resume-text-pdf" style={{paddingTop:15, paddingBottom:15}}>
                                      <div className='flex items-start justify-start'>
                                          <img class="avatar_left-pdf" src="/icons/tpAgentMini.png" alt="" style={{ marginLeft: 12 }} />
                                          <div className='flex flex-col items-start justify-start'>
                                              <div class="text-left-pdf">Polarity: {item.polarity}</div>
                                              <div class="text-left-pdf" style={{ color: '#575756',width:500 }}>{item.user}</div>
                                          </div>

                                      </div>

                                  </div>
                              }
                              <div style={{ display: 'flex', justifyContent: 'flex-end'}} >
                                  <p class="text-bot-pdf chat-bot-pdf" style={{ color: '#575756',width:500 }}>{item?.bot}
                                      <img class="avatar_right-pdf" src="/icons/tpClientMini.png" alt="" />
                                  </p>
                              </div>
                          </div>))}
                  </div>
              </div>
          </div>

      </div>

    </div>
  );
}